import { FC } from 'react';

import { IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { DeviceDetailsLine } from '../DeviceDetailsLine/DeviceDetailsLine';
import {
  IDeviceSessionIPLineProps,
  useDeviceSessionIPLinePresenter,
} from './DeviceSessionIPLine.presenter';
import styles from './DeviceSessionIPLine.styles.m.css';

export const DeviceSessionIPLine: FC<IDeviceSessionIPLineProps> = (props) => {
  const { t } = useTranslation();
  const presenter = useDeviceSessionIPLinePresenter(props);

  return (
    <DeviceDetailsLine
      className={styles.container}
      size="small-2"
      onClick={presenter.handleCopyToClipboard}
      label={t('common_ip')}
      Actions={
        <IconButton
          Icon={IcSCopyIcon}
          onClick={presenter.handleCopyToClipboard}
        />
      }
    >
      <span className={styles.ipAddress}>{props.ipAddress}</span>
    </DeviceDetailsLine>
  );
};
